import actions from './actions';
import { onLoadMultiDaySuccess } from '../common/reducers';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  jobs: null,
  loading: false,
  total: 0,
  filteredTotal: 0,
  jobGroup: null,
  savedSearches: undefined,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, jobGroup, filters, savedSearches } = payload;
  // Add additional children an empty array for Multi Days jobs to indicate expandable row in the table
  const jobs = data.map(record => {
    return record.multi_day ? { ...record, children: [] } : record;
  });

  return {
    ...state,
    jobs,
    total,
    filteredTotal,
    jobGroup,
    loading: false,
    filters,
    savedSearches,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.LOAD_MULTI_DAY_SUCCESS]: onLoadMultiDaySuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
